import { render } from "./OrderPartUpdate.vue?vue&type=template&id=1529c8f4&scoped=true"
import script from "./OrderPartUpdate.vue?vue&type=script&lang=js"
export * from "./OrderPartUpdate.vue?vue&type=script&lang=js"

import "./OrderPartUpdate.vue?vue&type=style&index=0&id=1529c8f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1529c8f4"]])

export default __exports__